import { AppThunk } from '../states/generateStore';
import { suiteCrmUrl, getNote } from './constants';
import shellSlice from '../states/shell/slice';
import snackBarSlice from '../states/snackbar/slice';

const onGetNote = (): AppThunk =>
  async (dispatch, getStore) => {
    // Create a fetch call to get Note from Suite
    try {
      const formData = new FormData();
      formData.append('action', 'read');

      const response = await fetch(suiteCrmUrl.concat(getNote),
        { 
          method: 'POST',
          body: formData
        }
      );

      const result = await response.json();
      if (result) {
        let tmpNote: any = {};
        Object.keys(result).forEach((key: any) => {
          if (result[key].title.includes("Daikin")) {
            tmpNote = { ...tmpNote, [key]: result[key] };
          }
        });
        tmpNote && dispatch(shellSlice.actions.updateNoteTemplate(tmpNote));
      } else {
        // show warning
        dispatch(snackBarSlice.actions.updateAlert({message: "Unable to load Note template from Server", severity: "warning"}));
        dispatch(snackBarSlice.actions.updateSnackBar(true));
      }
    } catch (err) {
      console.log(err);
      // show error
      dispatch(snackBarSlice.actions.updateAlert({message: "onGetNote: Can not get data from Server", severity: "error"}));
      dispatch(snackBarSlice.actions.updateSnackBar(true));
    }
  }
export default onGetNote;